module.exports = __webpack_public_path__ + "img/green-coconut.0daf0d59.jpg";